import { TEST_ID_PLAYER_ROSTER } from "e2e/testId";
import { CheckIcon } from "lucide-react-native";
import React, { memo } from "react";

import {
  Checkbox,
  CheckboxGroup,
  CheckboxIcon,
  CheckboxIndicator,
} from "@/components/atoms/Checkbox";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";
import { RosterManagementTeamFragment } from "@/generated/graphql";
import { ifWeb } from "@/utils/platform";

/**
 *
 */
interface Props {
  item: RosterManagementTeamFragment;
  hasSelectedTeam: boolean;
  onChange: (teamIds: string[]) => void;
}

/**
 * View for displaying a team item with checkbox selection.
 * @param root0 - Component props
 * @param root0.item - Team data to display
 * @param root0.hasSelectedTeam - Whether this team is selected for the organization
 * @param root0.onChange - Callback when team selection changes with team IDs
 */
const TeamItemView = ({ item, hasSelectedTeam, onChange }: Props) => (
  <Stack
    direction="horizontal"
    className={`items-center justify-between gap-3 ${ifWeb("py-3 px-4", "py-2")}`}
  >
    <Text
      variant="unstyled"
      className={`shrink font-heading ${ifWeb("text-title-lg", "text-display-sm")}`}
    >
      {item.name}
    </Text>
    <CheckboxGroup
      testID={
        hasSelectedTeam
          ? TEST_ID_PLAYER_ROSTER.TEAM_SELECTION_CHECKBOX_CHECKED
          : TEST_ID_PLAYER_ROSTER.TEAM_SELECTION_CHECKBOX_UNCHECKED
      }
      aria-label="checkbox group"
      onChange={onChange}
      value={hasSelectedTeam ? [item.id] : []}
    >
      <Checkbox aria-label={`${item.name} checkbox`} value={item.id}>
        <CheckboxIndicator>
          <CheckboxIcon
            as={CheckIcon}
            className="border-none bg-status-info text-content-on-accent"
            {...ifWeb({ size: "md" }, {})}
          />
        </CheckboxIndicator>
      </Checkbox>
    </CheckboxGroup>
  </Stack>
);

TeamItemView.displayName = "TeamItemView";

export default memo(TeamItemView);
